import React from "react";
import { FaLeaf, FaStar, FaShieldAlt, FaHeart, FaCheckCircle, FaIndustry, FaShieldVirus, FaTint } from "react-icons/fa";
import "./VangalProductsSection.css";

export default function VangalProductsSection() {
  return (
    <section className="vp-wrapper">
      {/* Title */}
      <h2 className="vp-title anim anim-top">PRODUCTS FROM OUR BASKET</h2>

      {/* Main Description */}
      <p className="vp-description anim anim-bottom">
        Vangal brings to you a wholesome range of dairy products crafted with purity, passion, 
        and the richness of fresh cow’s milk. From aromatic ghee and flavoursome butter to soft 
        artisan curds and premium varieties of paneer, every product is made with care. Taste the 
        authentic freshness, savour the natural goodness, and experience dairy like never before.
      </p>

      {/* Product Cards */}
      <div className="vp-products-grid anim anim-top">
        <div className="vp-card anim anim-bottom">
          <h3 className="vp-card-title">VANGAL BUTTER</h3>
          <p className="vp-card-desc">
            Pure, rich, natural and flavoursome — perfect for baking, cooking and enhancing taste.
          </p>
        </div>

        <div className="vp-card anim anim-bottom">
          <h3 className="vp-card-title">VANGAL GHEE</h3>
          <p className="vp-card-desc">
            Traditionally made from pure cow’s milk. Freshly melted, aromatic and free from additives.
          </p>
        </div>

        <div className="vp-card anim anim-bottom">
          <h3 className="vp-card-title">VANGAL CURDS</h3>
          <p className="vp-card-desc">
            Artisanal curds with a home-style taste. No stabilisers — just natural richness.
          </p>
        </div>

        <div className="vp-card anim anim-top">
          <h3 className="vp-card-title">VANGAL MALAI PANEER</h3>
          <p className="vp-card-desc">
            Incredibly soft and rich paneer made from wholesome cow’s milk — a recipe delight.
          </p>
        </div>

        <div className="vp-card anim anim-top">
          <h3 className="vp-card-title">GOPIKA FRESH PANEER</h3>
          <p className="vp-card-desc">
            Protein-rich paneer for health-conscious individuals — nutritious and balanced.
          </p>
        </div>

        <div className="vp-card anim anim-top">
          <h3 className="vp-card-title">GOPIKA LITE PANEER</h3>
          <p className="vp-card-desc">
            High protein, low fat — wholesome, light and budget-friendly.
          </p>
        </div>
      </div>

      {/* Values */}
      <h3 className="vp-quality-title anim anim-bottom">OUR VALUES</h3>

<div className="vp-quality-grid">
      {/* Row 1 */}
      <div className="vp-quality-card anim anim-top">
        <FaLeaf size={40} />
        <p>Freshness</p>
      </div>

      <div className="vp-quality-card anim anim-top">
        <FaStar size={40} />
        <p>Quality</p>
      </div>

      <div className="vp-quality-card anim anim-top">
        <FaShieldAlt size={40} />
        <p>Purity</p>
      </div>

      <div className="vp-quality-card anim anim-top">
        <FaHeart size={40} />
        <p>Care</p>
      </div>

      {/* Row 2 */}
      <div className="vp-quality-card anim anim-bottom">
        <FaIndustry size={40} />
        <p>Hygiene</p>
      </div>

      <div className="vp-quality-card anim anim-bottom">
        <FaCheckCircle size={40} />
        <p>Trust</p>
      </div>

      <div className="vp-quality-card anim anim-bottom">
        <FaShieldVirus size={40} />
        <p>Safety</p>
      </div>

      <div className="vp-quality-card anim anim-bottom">
        <FaTint size={40} />
        <p>Fresh Milk</p>
      </div>
    </div>

    </section>
  );
}
